import {NavLink} from "react-router-dom";
import React, {Fragment, useContext} from "react";
import {AuthContext} from "../context/authContext";
import ClientMainMenu from "./ClientLayout/ClientMainMenu";
import ProviderMainMenu from "./ProviderLayout/ProviderMainMenu";
import ProviderUserMenu from "./ProviderLayout/ProviderUserMenu";
import ClientUserMenu from "./ClientLayout/ClientUserMenu";
import logoImage from "../assets/small_logo.png";

const MainMenu = ({ excludeUserMenu = false }) => {
  const { user } = useContext(AuthContext)

  return <>
    <div className="col-md-2">
      <NavLink to='/' className="navbar-brand me-0 fs-5 w-auto" href="#">
        <img src={logoImage} width="50px" alt="logo" />
      </NavLink>
    </div>
    <ul className="navbar-nav col-md-8 justify-content-md-center main-menu ms-3">
      {!user &&
        <>
          <li className="nav-item">
            <NavLink to="/preturi" className="nav-link close-nav">Preturi</NavLink>
          </li>
        </>
      }
      {user && user.type === 'provider' && <ProviderMainMenu />}
      {user && user.type === 'client' && <ClientMainMenu />}
    </ul>
    <div className="d-md-flex col-md-2 justify-content-end pe-3">
      {!excludeUserMenu &&
        <Fragment>
          {user && user.type === 'provider' && <ProviderUserMenu />}
          {user && user.type === 'client' && <ClientUserMenu />}
        </Fragment>
      }
      {!user &&
        <>
          <hr />
          <NavLink to="/login" className="btn btn-outline-primary me-3 close-nav">Autentificare</NavLink>
          <NavLink to="/inregistrare" className="btn btn-primary close-nav">Inregistrare</NavLink>
        </>
      }
    </div>
  </>
}
export default MainMenu
